// @flow
import React, { Component } from 'react'
import Select from '../controls/Select'
import type { OptionType } from '../types'
import styled from 'styled-components'
import LabeledWrapper from './LabeledWrapper'

const SelectWrapper = styled.div`
  display: inline-block;
  width: 480px;
`

type Props = {|
  visible: boolean,
  options: Array<OptionType>,
  currentAdAccountId: number,
  adAccountErrors: Array<string>,
  onChange: Function
|}

const t = {
  ad_account_select_label: 'Выбор кабинета'
}

export default class AdAccountSelect extends Component<Props> {
  render() {
    const { visible, options, currentAdAccountId, adAccountErrors } = this.props
    if (!visible) return null

    return (
      <LabeledWrapper
        className="t-AdAccountSelect"
        errors={adAccountErrors}
        label={t.ad_account_select_label}
        twoLines
      >
        <SelectWrapper>
          <Select
            value={currentAdAccountId}
            options={options}
            onChange={(id) => this.changed({ currentAdAccountId: id })}
          />
        </SelectWrapper>
      </LabeledWrapper>
    )
  }

  changed(diff: Object) {
    this.props.onChange(diff)
  }
}
